import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PeriodicidadeCompraApi } from 'app/domains/environment/periodicidade-compra/api/periodicidade-compra.api';
import { ISelectOption } from '../select/models/select-option.interface';
import { ISelectSettings } from '../select/models/select-settings.interface';
import { ToastService } from '../toast/services/toast.service';
import { ApiError } from 'app/core/errors/api-error';
import { IPeriodicidadeCompraFilter } from 'app/domains/environment/periodicidade-compra/interfaces/periodicidade-compra-filter.interface';
import { EnumSituacao } from '../../enums/situacao.enum';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'sgt-periodicidade-compra-select',
  templateUrl: './periodicidade-compra-select.component.html',
  styleUrls: ['./periodicidade-compra-select.component.scss'],
})
export class PeriodicidadeCompraSelectComponent implements OnInit {
  public selectorOptionsPeriodicidadeCompras: ISelectOption[] = [];

  filter: IPeriodicidadeCompraFilter = {
    situacoes: EnumSituacao.ATIVO,
    sort: 'nome',
    sortDir: 'desc',
  };

  @Output() changed = new EventEmitter<number>();

  @Input() selectorSettings!: ISelectSettings;
  @Input() pendingSelectionId?: number;
  @Input() isToShowTabelaVigenciaCarteiraCliente = false;
  @Input() enableAutoSelectSingleOption = false;

  constructor(
    private periodicidadeCompraApi: PeriodicidadeCompraApi,
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.loadPeriodicidadeCompras();
  }

  private loadPeriodicidadeCompras() {
    this.definirCarregando(true);

    this.periodicidadeCompraApi
      .fetchPeriodicidadesComprasList(this.filter)
      .pipe(finalize(() => this.definirCarregando(false))).subscribe({
        next: (response) => {
          const periodicidadeCompraSummaryList = response.data;

          // Defini opções do seletor
          this.selectorOptionsPeriodicidadeCompras =
            periodicidadeCompraSummaryList.map((periodicidadeCompra) => ({
              id: periodicidadeCompra.id,
              label: periodicidadeCompra.nome,
            }));

          // Aplica a seleção automaticamente quando o auto-select está habilitado e a lista contém apenas uma única opção
          if (
            periodicidadeCompraSummaryList.length === 1 &&
            this.enableAutoSelectSingleOption
          ) {
            const id = periodicidadeCompraSummaryList[0].id;
            this.setSelection(id);
            this.emitSelected(id);
            return;
          }

          if (this.pendingSelectionId) {
            this.setSelection(this.pendingSelectionId);
            this.pendingSelectionId = undefined;
          }
        },
        error: (err: ApiError) => {
          this.toastService.error(err.message, {
            title: err.cause || 'Aconteceu algo inesperado.',
            duration: 5000,
          });
        },
      });
  }

  setSelection(id: number) {
    if (!this.selectorOptionsPeriodicidadeCompras.length) {
      this.pendingSelectionId = id;
      return;
    }

    this.selectorOptionsPeriodicidadeCompras =
      this.selectorOptionsPeriodicidadeCompras.map((option) => ({
        ...option,
        isSelected: option.id === id,
      }));
  }

  onChangePeriodicidadeCompra(periodicidadeCompra: ISelectOption) {
    this.emitSelected(Number(periodicidadeCompra.id));
  }

  public clearSelection(): void {
    this.setSelection(null);
  }

  private emitSelected(id: number) {
    this.changed.next(id);
  }

  private definirCarregando(carregando: boolean): void {
    this.selectorSettings = { ...this.selectorSettings, isLoading: carregando };
  }

}
